<div class="auth-client">
  <strong class="auth-client__phone-preview">
    {{ phonePreview() }}
  </strong>

  @if (message()) {
    <div class="auth-client__state auth-client__state--info">
      <i class="bx bx-info-circle"></i>
      <span>{{ message() }}</span>
    </div>
  }

  @if (mode() !== 'identified') {
<lib-input
  id="auth-client-phone"
  type="tel"
  legend="Telefone"
  placeholder="(11) 99999-9999"
  [control]="phoneControl"
  [usePhoneMask]="true"
  [emitBlur]="lookupOnPhoneBlur()"
  (fieldBlurred)="onPhoneBlur()"
></lib-input>
  }

  @if (lookingUp()) {
    <div class="auth-client__state auth-client__state--info">
      <i class="bx bx-loader-alt auth-client__spin"></i>
      <span>Consultando seu cadastro...</span>
    </div>
  }

  @if (error()) {
    <div class="auth-client__state auth-client__state--error" role="alert">
      <i class="bx bx-error-circle"></i>
      <span>{{ error() }}</span>
    </div>
  }

  @if (mode() === 'login' || mode() === 'identified') {
    <div class="auth-client__summary">
      <strong>{{ customerName() }}</strong>
      <span>{{ customerEmail() || 'Sem e-mail cadastrado' }}</span>
    </div>
  }

  @if (mode() === 'register') {
    <div class="auth-client__field">
      <label class="auth-client__label" for="auth-client-name">
        Nome *
      </label>

      <input
        id="auth-client-name"
        class="auth-client__input"
        type="text"
        [ngModel]="customerName()"
        (ngModelChange)="customerName.set($event)"
        name="authClientName"
        placeholder="Seu nome completo"
        required
      />
    </div>

    <div class="auth-client__field">
      <label class="auth-client__label" for="auth-client-email">
        E-mail
      </label>

      <input
        id="auth-client-email"
        class="auth-client__input"
        type="email"
        [ngModel]="customerEmail()"
        (ngModelChange)="customerEmail.set($event)"
        name="authClientEmail"
        placeholder="voce@email.com"
      />
    </div>
  }

  @if (mode() !== 'lookup' && mode() !== 'identified') {
    <div class="auth-client__field">
      <label class="auth-client__label" for="auth-client-birth-date">
        Data de nascimento *
      </label>

      <input
        id="auth-client-birth-date"
        class="auth-client__input"
        type="date"
        [ngModel]="birthDateInput()"
        (ngModelChange)="birthDateInput.set($event)"
        name="authClientBirthDate"
        required
      />

      <span class="auth-client__helper">
        Usamos apenas dia e mes para validar sua identificacao.
      </span>
    </div>
  }
</div>